
import * as gs from "@ivanlog/gs";
import * as com from "./tmpls";
import {CmpBtnInfo} from "./CmpBtnInfo";
import {CmpHeader} from "./CmpHeader";
import {CmpHeroVX} from "./CmpHeroVX";
import {CmpInputAddress} from "./CmpInputAddress";
import {CmpInputIndex} from "./CmpInputIndex";
import {CmpInputTokenAmount} from "./CmpInputTokenAmount";
import {CmpModalDialog} from "./CmpModalDialog";
import {CmpRange} from "./CmpRange";
import {CmpSelectERC20} from "./CmpSelectERC20";
import {CmpWgtLPXNew} from "./CmpWgtLPXNew";
import {CmpWidgetChart} from "./CmpWidgetChart";
import {CmpWidgetLPXControl} from "./CmpWidgetLPXControl";
import {CmpWidgetLPXCtrl} from "./CmpWidgetLPXCtrl";
import {CmpWidgetLPXCtrlTabStartPool} from "./CmpWidgetLPXCtrlTabStartPool";
import {CmpWidgetLPXDetails} from "./CmpWidgetLPXDetails";
import {CmpWidgetLPXTable} from "./CmpWidgetLPXTable";
import {CmpWidgetShareXSaved} from "./CmpWidgetShareXSaved";
import {CmpWidgetShareXTable} from "./CmpWidgetShareXTable";
import {CmpWidgetShareXTokens} from "./CmpWidgetShareXTokens";
import {CmpWidgetVXApp} from "./CmpWidgetVXApp";
import {CmpWidgetVXSApp} from "./CmpWidgetVXSApp";
import {CmpWidgetVXStatus} from "./CmpWidgetVXStatus";

export const InjectComponents = () => { };
gs.WrapperGS.InjectComponents(CmpBtnInfo,'cmpBtnInfo')
gs.WrapperGS.InjectComponents(com.CmpBtnWithTag,'cmpBtnWithTag')
gs.WrapperGS.InjectComponents(com.CmpFooterLPX,'cmpFooterLPX')
gs.WrapperGS.InjectComponents(com.CmpFooterShareX,'cmpFooterShareX')
gs.WrapperGS.InjectComponents(com.CmpFooterVX,'cmpFooterVX')
gs.WrapperGS.InjectComponents(com.CmpFormItemAddressPath,'cmpFormItemAddressPath')
gs.WrapperGS.InjectComponents(CmpHeader,'cmpHeader')
gs.WrapperGS.InjectComponents(com.CmpHeroLPX,'cmpHeroLPX')
gs.WrapperGS.InjectComponents(com.CmpHeroShareX,'cmpHeroShareX')
gs.WrapperGS.InjectComponents(CmpHeroVX,'cmpHeroVX')
gs.WrapperGS.InjectComponents(com.CmpInfo3Steps,'cmpInfo3Steps')
gs.WrapperGS.InjectComponents(CmpInputAddress,'cmpInputAddress')
gs.WrapperGS.InjectComponents(CmpInputIndex,'cmpInputIndex')
gs.WrapperGS.InjectComponents(CmpInputTokenAmount,'cmpInputTokenAmount')
gs.WrapperGS.InjectComponents(com.CmpInputTokens,'cmpInputTokens')
gs.WrapperGS.InjectComponents(com.CmpInputTokensSwap,'cmpInputTokensSwap')
gs.WrapperGS.InjectComponents(CmpModalDialog,'cmpModalDialog')
gs.WrapperGS.InjectComponents(com.CmpPriceRange,'cmpPriceRange')
gs.WrapperGS.InjectComponents(CmpRange,'cmpRange')
gs.WrapperGS.InjectComponents(com.CmpSearch,'cmpSearch')
gs.WrapperGS.InjectComponents(CmpSelectERC20,'cmpSelectERC20')
gs.WrapperGS.InjectComponents(com.CmpTableHeaderERC20,'cmpTableHeaderERC20')
gs.WrapperGS.InjectComponents(com.CmpTableHeaderLPX,'cmpTableHeaderLPX')
gs.WrapperGS.InjectComponents(com.CmpTableHeaderShareX,'cmpTableHeaderShareX')
gs.WrapperGS.InjectComponents(com.CmpTableItemERC20,'cmpTableItemERC20')
gs.WrapperGS.InjectComponents(com.CmpTableItemLPX,'cmpTableItemLPX')
gs.WrapperGS.InjectComponents(com.CmpTableItemShareX,'cmpTableItemShareX')
gs.WrapperGS.InjectComponents(CmpWgtLPXNew,'cmpWgtLPXNew')
gs.WrapperGS.InjectComponents(CmpWidgetChart,'cmpWidgetChart')
gs.WrapperGS.InjectComponents(com.CmpWidgetInfoLPX,'cmpWidgetInfoLPX')
gs.WrapperGS.InjectComponents(com.CmpWidgetInfoSV,'cmpWidgetInfoSV')
gs.WrapperGS.InjectComponents(com.CmpWidgetInfoTokenTiers,'cmpWidgetInfoTokenTiers')
gs.WrapperGS.InjectComponents(com.CmpWidgetInfoUDex,'cmpWidgetInfoUDex')
gs.WrapperGS.InjectComponents(com.CmpWidgetInfoVX,'cmpWidgetInfoVX')
gs.WrapperGS.InjectComponents(com.CmpWidgetInfoVXS,'cmpWidgetInfoVXS')
gs.WrapperGS.InjectComponents(CmpWidgetLPXControl,'cmpWidgetLPXControl')
gs.WrapperGS.InjectComponents(CmpWidgetLPXCtrl,'cmpWidgetLPXCtrl')
gs.WrapperGS.InjectComponents(CmpWidgetLPXCtrlTabStartPool,'cmpWidgetLPXCtrlTabStartPool')
gs.WrapperGS.InjectComponents(CmpWidgetLPXDetails,'cmpWidgetLPXDetails')
gs.WrapperGS.InjectComponents(com.CmpWidgetLPXHowWork,'cmpWidgetLPXHowWork')
gs.WrapperGS.InjectComponents(com.CmpWidgetLPXNewDep,'cmpWidgetLPXNewDep')
gs.WrapperGS.InjectComponents(com.CmpWidgetLPXStatus,'cmpWidgetLPXStatus')
gs.WrapperGS.InjectComponents(CmpWidgetLPXTable,'cmpWidgetLPXTable')
gs.WrapperGS.InjectComponents(CmpWidgetShareXSaved,'cmpWidgetShareXSaved')
gs.WrapperGS.InjectComponents(CmpWidgetShareXTable,'cmpWidgetShareXTable')
gs.WrapperGS.InjectComponents(CmpWidgetShareXTokens,'cmpWidgetShareXTokens')
gs.WrapperGS.InjectComponents(CmpWidgetVXApp,'cmpWidgetVXApp')
gs.WrapperGS.InjectComponents(CmpWidgetVXSApp,'cmpWidgetVXSApp')
gs.WrapperGS.InjectComponents(CmpWidgetVXStatus,'cmpWidgetVXStatus')
gs.WrapperGS.InjectComponents(com.LayoutMain,'layoutMain')
gs.WrapperGS.InjectComponents(com.PageLoadingLPX,'pageLoadingLPX')
gs.WrapperGS.InjectComponents(com.PageLoadingShareX,'pageLoadingShareX')
gs.WrapperGS.InjectComponents(com.PageLoadingVX,'pageLoadingVX')
gs.WrapperGS.InjectComponents(com.PageLPX,'pageLPX')
gs.WrapperGS.InjectComponents(com.PageShareX,'pageShareX')
gs.WrapperGS.InjectComponents(com.PageVX,'pageVX')